import { apiClient } from './client'
import type {
  RefOtdFilial,
  FilialBindingFilters,
  OtdFilialsResponse,
  BulkUpdateRequest,
  PeriodsResponse,
  PeriodCheckResponse,
  CurrentStructureResponse,
  CurrentStructureFilters,
} from '@/types/refOtdFilials'

export const getPeriods = async (): Promise<PeriodsResponse> => {
  const response = await apiClient.get('/refs/otd-filials/periods')
  return response.data
}

export const checkPeriod = async (period: string): Promise<PeriodCheckResponse> => {
  const response = await apiClient.get(`/refs/otd-filials/periods/${period}/check`)
  return response.data
}

export const getOtdFilials = async (
  filters: FilialBindingFilters
): Promise<OtdFilialsResponse> => {
  const params = {
    period: filters.period,
    address: filters.address,
    fil_code: filters.fil_code,
    status: filters.status,
    page: filters.page || 1,
    page_size: filters.page_size || 50,
    without_filial: filters.without_filial,
    serv_code: filters.serv_code,
    is_surgical: filters.is_surgical,
    search: filters.search,
  }

  const response = await apiClient.get('/refs/otd-filials/', { params })
  return response.data
}

export interface BindingUpdate {
  fil_code?: number | null
  serv_code?: number | null
  is_surgical?: boolean | null
}

export const updateBinding = async (
  id_otd: string,
  period: string,
  data: BindingUpdate
): Promise<RefOtdFilial> => {
  const response = await apiClient.patch(
    `/refs/otd-filials/${encodeURIComponent(id_otd)}/`,
    data,
    { params: { period } }
  )
  return response.data
}

// Backwards compatibility
export const updateFilialBinding = async (
  id_otd: string,
  period: string,
  fil_code: number | null
): Promise<RefOtdFilial> => {
  return updateBinding(id_otd, period, { fil_code })
}

export const bulkUpdateFilials = async (
  request: BulkUpdateRequest
): Promise<void> => {
  await apiClient.post('/refs/otd-filials/bulk-update/', request)
}

export const getCurrentStructure = async (
  filters: CurrentStructureFilters
): Promise<CurrentStructureResponse> => {
  const params = {
    fil_code: filters.fil_code,
    search: filters.search,
    status: filters.status,
    without_filial: filters.without_filial,
    page: filters.page || 1,
    page_size: filters.page_size || 50,
  }

  const response = await apiClient.get('/refs/otd-filials/current-structure', { params })
  return response.data
}
